(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eofy-countdown-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aox-promo-countdown')) {
    customElements.define('aox-promo-countdown', class extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.deadline);
        this.fields = ['hours', 'minutes', 'seconds', 'milliseconds'].map((unit) => this.querySelector(`[data-${unit}]`));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onVisibilityChange = () => this.start();
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.start();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      start() {
        clearInterval(this.timer);
        if (!Number.isFinite(this.deadline) || this.fields.some((field) => !field)) {
          this.hidden = true;
          return;
        }
        if (this.update() && !document.hidden) {
          this.timer = setInterval(() => this.update(), this.reducedMotion ? 1000 : 50);
        }
      }

      update() {
        const remaining = Math.max(0, this.deadline - Date.now());
        this.hidden = remaining === 0;
        const values = [
          Math.floor(remaining / 3600000),
          Math.floor(remaining / 60000) % 60,
          Math.floor(remaining / 1000) % 60,
          this.reducedMotion ? 0 : remaining % 1000
        ];
        this.fields.forEach((field, index) => {
          const value = String(values[index]).padStart(index === 3 ? 3 : 2, '0');
          if (field.textContent !== value) field.textContent = value;
        });
        if (remaining === 0) clearInterval(this.timer);
        return remaining > 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
